module.exports = __webpack_public_path__ + "img/chengyun66.39cccca3.png";